import { NavLink } from "react-router-dom";
import { serviceData } from "../../../../globals/serviceDetail"; // Adjust path as needed

function SectionServices1() {
    // Take first 8 services from serviceDetail
    const Services = Object.entries(serviceData).slice(0, 8);

    // Icon mapping for different services (similar to SectionWhyChooseUs1)
    const iconMapping = {
        businessIntelligence: "flaticon-chart",
        creditScore: "flaticon-data",
        dataStrategyConsultation: "flaticon-parking",
        dataMiningProcessing: "flaticon-programmer",
        predictiveAnalysis: "flaticon-positive-review",
        sentimentAnalysis: "flaticon-profit",
        dataVisualizationLiveDashboards: "flaticon-chart",
        webAnalytics: "flaticon-data",
        buildingRecommendedSystems: "flaticon-programmer",
        softwareDevelopment: "flaticon-positive-review",
    };

    return (
        <>
            <div className="section-full p-t110 p-b80 sx-our-services-outer sx-bg-light">
                <div className="container">
                    {/* TITLE START */}
                    <div className="section-head center">
                        <div className="sx-head-s-title">Our Services</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title">Here’s a brief overview of some of the services we offer.</h2>
                        </div>
                    </div>
                    {/* TITLE END */}
                    <div className="section-content">
                        <div className="sx-our-services-bx">
                            <div className="row">
                                {Services.map(([serviceKey, service], index) => (
                                    <div key={serviceKey} className="col-lg-3 col-md-6 col-sm-6 mb-4 wow fadeInDown" data-wow-duration="1000ms">
                                        <div className="sx-service-bx-1">
                                            <div className="sx-icon-box-wraper">
                                                <NavLink 
                                                    to={`/services/detail/${serviceKey}`} 
                                                >
                                                <div className="sx-service-bx-icon scale-in-center">
                                                    <span className="sx-text-primary">
                                                        <i className={iconMapping[serviceKey] || "flaticon-security"} />
                                                    </span>
                                                </div>
                                                <div className="icon-content">
                                                    <h4 className="sx-tilte">{service.title}</h4>                                                    
                                                </div>
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionServices1;